import React from 'react';
import Peep from 'react-peeps';
import { BustPose } from 'react-peeps/lib/peeps/pose/bust/z_options';
import { BodyViewBox, CardBackground, CardBackgroundSelected } from '../constants.mjs';
// import { SittingPose } from 'react-peeps/lib/peeps/pose/sitting/z_options';
// import { StandingPose } from 'react-peeps/lib/peeps/pose/standing/z_options';

const BodySelector = ({setAvatarState, avatarState}) => {
    return (
        <div className={'grid grid-cols-4 overflow-y-scroll overflow-hidden no-scrollbar w-full flex h-48'}>
            {Object.keys(BustPose).map((pose) => {
                const isSelected = avatarState.body === pose.toString();
                return <button key={pose.toString()} margin={2} onClick={() => 
                    setAvatarState({
                        ...avatarState,
                        body: pose.toString()
                    })}>
                        <div className={isSelected ? CardBackgroundSelected : CardBackground} key={pose.toString()} margin={2}>
                            <Peep
                                style={{
                                    width: '100%',
                                    height: '100%',
                                    justifyContent: 'center',
                                    alignSelf: 'center'
                                }}
                                body={pose.toString()}
                                viewBox={BodyViewBox}
                            />
                        </div>
                    </button>
                
                })
            }
            {/* {Object.keys(SittingPose).map((pose) => {
                return <div className={'w-32 h-32 bg-blue-200'} key={pose.toString()} margin={2}>
                    <Peep
                        style={{
                            width: '100%',
                            height: '100%',
                            justifyContent: 'center',
                            alignSelf: 'center'
                        }}
                        body={pose.toString()}
                        viewBox={{ x: '-50', y: '500', width: '1000', height: '800' }}
                    />
                </div>
                })
            }
            {Object.keys(StandingPose).map((pose) => {
                return <div className={'w-32 h-32 bg-green-200'} key={pose.toString()} margin={2}>
                    <Peep
                        style={{
                            width: '100%',
                            height: '100%',
                            justifyContent: 'center',
                            alignSelf: 'center'
                        }}
                        body={pose.toString()}
                        viewBox={{ x: '-50', y: '400', width: '1000', height: '800' }}
                    />
                </div>
                })
            } */}
        </div>
    );
}
export default BodySelector;